import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

const REFERRAL_KEY = 'sayitnow_ref';

/**
 * Captures referral code from URL params (?ref=xxx) and stores in localStorage.
 * Also tracks a click in the influencer_codes table.
 * Persists until signup is completed.
 */
export function useReferralCapture() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref');
    if (ref) {
      localStorage.setItem(REFERRAL_KEY, ref);

      // Track influencer click (fire-and-forget, no auth required)
      supabase.rpc('track_influencer_click', { p_ref_code: ref }).then(() => {});

      // Clean the URL without triggering navigation
      const url = new URL(window.location.href);
      url.searchParams.delete('ref');
      window.history.replaceState({}, '', url.toString());
    }
  }, []);
}

export function getReferralCode(): string | null {
  return localStorage.getItem(REFERRAL_KEY);
}

export function clearReferralCode() {
  localStorage.removeItem(REFERRAL_KEY);
}
